import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiActivity } from 'react-icons/fi';
import './ZapTalkMoodTrackerPage.css';
import ZapTalkSmartCheckIn from './chat/components/ZapTalkSmartCheckIn';
import { useProtectedRoute } from '../../hooks/useProtectedRoute';
import { useColorMode } from '../../context/ColorModeContext';

type MoodTrackerRouteState = {
  topic?: string;
  from?: string;
  chatMode?: string;
};

const GLOBAL_MOOD_TRACKER_TOPIC = 'Mental Health';

const ZapTalkMoodTrackerPage: React.FC = () => {
  useProtectedRoute();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = useColorMode();
  const isDarkMode = mode === 'dark';
  const routeState = (location.state as MoodTrackerRouteState | null) ?? null;

  const topic = useMemo(() => GLOBAL_MOOD_TRACKER_TOPIC, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/chat', {
      state: {
        chatMode: 'zaptalk',
        subject: 'Mental Health',
      },
    });
  };

  return (
    <div className={`zaptalk-mood-page ${isDarkMode ? 'dark' : 'light'}`}>
      <main className="zaptalk-mood-page__content">
        <div className="zaptalk-mood-page__header">
          <button type="button" className="zaptalk-mood-page__back-btn" onClick={handleBack}>
            <FiArrowLeft size={16} />
            Back to chat
          </button>
          <div className="zaptalk-mood-page__topic-pill">
            <FiActivity size={14} />
            <span>{topic}</span>
          </div>
        </div>

        <ZapTalkSmartCheckIn
          isDarkMode={isDarkMode}
          topic={topic}
          asPage
        />
      </main>
    </div>
  );
};

export default ZapTalkMoodTrackerPage;
